import styled, { css } from "styled-components";
import { useSelector } from "react-redux";

import { payment as statuses } from "globalConstants";
import { ReduxStates } from "Types";
import { Payment as PaymentType } from "Types/Reducers";

import MoleculeFormPayment from "Components/Molecules/FormPayment";
import MoleculeFormTotal from "Components/Molecules/FormTotal";
import MoleculeFormWithoutPassbook from "Components/Organisms/FormWithoutPassbook";

export type PropsType = any;

const Wrap = styled.div<any>``;

export default function OrganismForm5(props: PropsType) {
   const payment = useSelector((state: { [key in keyof ReduxStates]: PaymentType }) => state.payment.type);
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <MoleculeFormPayment></MoleculeFormPayment>
         <MoleculeFormTotal
            css={css`
               margin-top: 20px;
            `}>
            22,000
         </MoleculeFormTotal>
         {payment === statuses.withoutPassbook && <MoleculeFormWithoutPassbook></MoleculeFormWithoutPassbook>}
      </Wrap>
   );
}
